import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import {getWebAuthHost, getWebHost} from "@/api/base";
import {setToken} from "@/utils/utils";
import {toLogin} from "@/router/utils";
import {setLang} from "@/lang/utils";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/generate',
    children: [
      {
        path: 'showcase',
        component: () => import('@/views/homePages/Showcase'),
        name: 'showcase',
        meta: { title: '示例预览', noCache: true }
      },
      {
        path: 'training',
        component: () => import('@/views/homePages/Training'),
        name: 'training',
        meta: { title: '训练', noCache: true }
      },
      {
        path: 'textGen',
        component: () => import('@/views/homePages/TextGen.vue'),
        name: 'textGen',
        meta: { title: '文本生成', noCache: true }
      },
      {
        path: 'generate',
        component: () => import('@/views/homePages/Generate'),
        name: 'generate',
        meta: { title: '图片生成', noCache: true }
      },
      {
        path: 'videoGen',
        component: () => import('@/views/homePages/VideoGen'),
        name: 'videoGen',
        meta: { title: '视频生成', noCache: true }
      },
      {
        path: 'modelGen',
        component: () => import('@/views/homePages/ModelGen.vue'),
        name: 'modelGen',
        meta: { title: '模型生成', noCache: true }
      },
      {
        path: 'my',
        component: () => import('@/views/homePages/My.vue'),
        name: 'my',
        meta: { title: '我的', noCache: true }
      },
    ]
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/Login')
  // },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})


router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('access_token')
  let query = to.query

  // 设置语言
  let lang = query.lang
  if (lang !== undefined) {
    setLang(lang)
    delete query.lang
  }

  if (!token) {
    if (query.token) {
      token = query.token
      setToken(token)
      delete query.token
      next({...to, query})
      return
    }
    toLogin()
  } else {
    if (query.token) {
      delete query.token
      next({...to, query})
    } else {
      next()
    }
  }
})

export default router
